import React from 'react';
import { withStyles } from '@material-ui/core/styles';
import { Typography } from '@material-ui/core';
import PropTypes from 'prop-types';
import cx from 'classnames';

const styles = theme => ({
  root: {
    overflow: 'hidden',
    backgroundColor: '#fff',
    borderRadius: 8,
  },
  title: {
    fontSize: 16,
  },
  cardContent: {
    position: 'relative',
    padding: '20px 13.8px 20px 13.8px',
    [theme.breakpoints.up('md')]: {
      padding: '22px 26px',
    },
  },
  titleWrapper: {
    display: 'flex',
    justifyContent: 'space-between',
    padding: '15.6px 13.8px 10.8px 13.8px',
    alignItems: 'center',
    borderBottom: '1px solid #EBEDF2',
    [theme.breakpoints.up('md')]: {
      padding: '15.6px 26px 10.8px 26px',
    },
  },
  footerContent: {
    borderTop: '1px solid #E1E4EB',
    paddingTop: 18,
    paddingBottom: 18,
  },
  cardContentNoPadding: {
    padding: 0,
  },
  withBorder: {
    boxShadow:
      '0 2px 4px -1px rgb(0 0 0 / 4%), 0 4px 5px 0 rgb(0 0 0 / 7%), 0 1px 10px 0 rgb(0 0 0 / 11%)',
  },
});

const CardDisplay = ({
  classes,
  children,
  title = '',
  rightContent,
  footerContent,
  noPadding = false,
  withBorder = false,
}) => (
  <div className={cx([classes.root], { [classes.withBorder]: withBorder })}>
    {title && (
      <div className={classes.titleWrapper}>
        <Typography className={classes.title}>
          <b>{title}</b>
        </Typography>
        {rightContent && <Typography className={classes.rightContent}>{rightContent}</Typography>}
      </div>
    )}
    <div className={cx(classes.cardContent, { [classes.cardContentNoPadding]: noPadding })}>
      {children}
    </div>
    {footerContent && <div className={classes.footerContent}>{footerContent}</div>}
  </div>
);

CardDisplay.propTypes = {
  title: PropTypes.string,
  children: PropTypes.any,
  rightContent: PropTypes.node,
  footerContent: PropTypes.node,
  classes: PropTypes.object.isRequired,
  noPadding: PropTypes.bool,
  withBorder: PropTypes.bool,
};

export default withStyles(styles)(CardDisplay);
